<template>
  <el-form-item :label="`${labelText}`" :label-width="labelWidth">
    <div class="buttonGroup">
      <el-upload
        class="upload"
        action="/jd-hd-web/image/upload"
        :accept="accept"
        :show-file-list="false"
        :before-upload="beforeUploadUI"
        :on-success="handleUploadUI"
      >
        <div class="bg-wrap" v-if="customerPaperwork[bgKey]">
          <img :src="customerPaperwork[bgKey]" class="bg-wrap-img" />
        </div>
        <jd-button
          v-else
          :type="btnType"
          label="自定义上传"
          :disabled="backgroundOpacity"
        ></jd-button>
      </el-upload>
      <jd-button
        type="blueText"
        @click="customerPaperwork[bgKey] = ''"
        class="ml16"
        :disabled="backgroundOpacity"
        >重置</jd-button
      >
      <span class="size-tip" v-if="isShowSizeTip">尺寸建议：{{pw}}*{{ph}}px <slot name="sizeTip"></slot></span>
    </div>
  </el-form-item>
</template>
<script>
const ALLOWED_EXTENSIONS = [".png", ".jpg"];
const DEFAULT_WIDTH = 200;
const DEFAULT_HEIGHT = 200;
export default {
  props: {
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    labelText: {
      type: String,
      default: "背景:",
    },
    bgKey: {
      type: String,
      default: "",
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    pw: {
      type: Number,
      default: DEFAULT_WIDTH,
    },
    ph: {
      type: Number,
      default: DEFAULT_HEIGHT,
    },
    labelWidth: {
      type: String,
      default: "90px",
    },
    bgLabelText: {
      type: String,
      default: "",
    },
    isLimitSize: {
      type: Boolean,
      default: false,
    },
    isShowSizeTip: {
      type: Boolean,
      default: true,
    },
    btnType: {
      type: String,
      default: "blueLine",
    },
    extensions: {
      type: Array,
      default: () => ALLOWED_EXTENSIONS,
    },
    accept: {
      type: String,
      default: ".jpg,.png",
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    imgchecked(file, width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        const _URL = window.URL || window.webkitURL;

        image.onload = () => {
          const valid = image.width === width && image.height === height;
          file.isFlag = valid;

          if (valid) {
            resolve(true);
          } else {
            this.$message.info("图片尺寸不符合要求，请重新上传");
            reject();
          }
        };

        image.src = _URL.createObjectURL(file);
      });
    },

    async beforeUploadUI(file) {
      const extension = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();

      if (!this.extensions.includes(extension)) {
        this.$message.info("所选图片格式不符，请重新选择");
        return reject();
      }
      if (!this.isLimitSize) {
        return true;
      }

      try {
        await this.imgchecked(file, this.pw, this.ph);
        return true;
      } catch {
        return false;
      }
    },

    handleUploadUI(res) {
      if (res.code !== 1) {
        this.$message.error(res.message || "上传失败");
      } else {
        this.customerPaperwork[this.bgKey] = res.data;
        this.$message.success(`${this.bgLabelText}上传成功`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.buttonGroup {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #666;
  .bg-wrap {
    width: 80px;
    &-img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }
  .size-tip {
    color: #999;
    margin-left: 12px;
  }
}
</style>
